import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { LoadingKey } from 'utils/promise';

interface LoadingState {
  loadingKeys: Record<string, boolean>; // 각 로딩 상태를 키로 관리
  setLoading: (key: string, loading: boolean) => void;
  checkIsQuerying: (key: LoadingKey) => boolean;
  checkIsMutationing: (key?: LoadingKey) => boolean;
}

/**
 * 키에 대한 상태값이 undefined | true => 로딩 중
 * 키에 대한 상태값이 false여야 로딩 완료
 */

export const useLoadingStore = create<LoadingState>()(
  devtools(
    (set, get) => ({
      loadingKeys: {},
      setLoading: (key, loading) =>
        set(
          (state) => ({
            loadingKeys: { ...state.loadingKeys, [key]: loading },
          }),
          false,
          `setLoading(${key})`
        ),
      checkIsQuerying: (key) => {
        const isLoadingStatus = get().loadingKeys[key] === undefined || get().loadingKeys[key] === true;
        if (isLoadingStatus) return true;
        return false;
      },
      checkIsMutationing: (key) => {
        const loadingKeys = get().loadingKeys;
        return key ? loadingKeys[key] : false;
      },
    }),
    { name: 'LoadingStore' }
  )
);
